import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import './BetSlipModal.scss';
import { RootState } from '../../../configs/store';
import BottomMenuContext from '../../BottomMenu/Context/BottomMenu.context';
import Betslip from '../Betslip/Betslip';
import BetResult from '../BetResult/BetResult';
import Icon from '../../Icon/Icon';
import MyBets from '../MyBets/MyBets';

interface BetslipModalProps {
  myBets?: boolean
}

function BetslipModal({ myBets = false } : BetslipModalProps) {
  const { bets, betResult } = useSelector((state: RootState) => state.betslip);
  const { t } = useTranslation('common');
  const { handleOpen, myBetsCount } = useContext(BottomMenuContext);

  const renderMyBetsWrapper = () => {
    return (
      <>
        {
          !_.isEmpty(betResult)
            ? <BetResult />
            : (
              <div className="betslip-modal__empty">
                { t('betslip.noBets') }<br />{ t('betslip.toSelect') }
              </div>
            )
        }
      </>
    );
  };

  const maxHeight = window.innerHeight - 40;
  let toolTipCount = 0;
  if (myBets && myBetsCount > 0) {
    toolTipCount = myBetsCount;
  } else if (!myBets && bets.length > 0) {
    toolTipCount = bets.length;
  }

  return (
    <div className="betslip-modal" style={ { maxHeight } }>
      <div className="betslip-modal__header">
        <span className="betslip-modal__title-container">
          <span>{ myBets ? t('betslip.myBetsTab') : t('betslip.betslipTab') }</span>
          { toolTipCount > 0 && <span className="betslip-modal__tab-tooltip">{ toolTipCount }</span> }
        </span>
        <Icon icon="close" className="betslip-modal__title-close" onClick={ () => handleOpen('') } />
      </div>
      <div className="betslip-container">
        { !myBets && bets.length > 0 && _.isNull(betResult) && <Betslip /> }
        { myBets && <MyBets /> }
        { (bets.length === 0 || !_.isNull(betResult)) && !myBets && renderMyBetsWrapper() }
      </div>
    </div>
  );
}

export default BetslipModal;
